module.exports = __webpack_public_path__ + "static/media/peace-land.1151dbc9.png";